import useUserProfile from '@/hooks/useUserProfile';
import Search from '@ui/Search';
import { ToggleButton } from '@ui/ToggleButton';
import Typography from '@ui/Typography';
import { API_BASE_URL } from '@utils/constants';
import { authorizedServerFetch } from 'actions/server.actions';
import StyledContainedButton from 'components/Styled/StyledContainedButton';
import { isEmpty, sortBy, values } from 'lodash-es';
import Image from 'next/image';
import React from 'react';
// import Loading from 'components/Loading';

function EditProfileCausesStep(props) {
  const { userProfile, onSubmit, onBack, formData, onNext, onChange, saving } =
    props;
  const [causes, setCauses] = React.useState([]);
  const [selectedCauses, setSelectedCauses] = React.useState({});
  const [searchedCauses, setSearchedCauses] = React.useState([]);
  let userData = useUserProfile();
  userData = userProfile || userData;

  const fetchCauses = async () => {
    try {
      const { data } = await authorizedServerFetch('causes');
      setCauses(sortBy(data, 'cause_title'));
    } catch (err) {
      console.log('EditProfileCausesStep', err);
    }
  };

  const updateSelectedCauses = (selected) => {
    setSelectedCauses(selected);
    onChange(values(selected));
  };

  // fetch all causes
  React.useEffect(() => {
    fetchCauses();
  }, [userData]);

  // prepopulate the selected list
  React.useEffect(() => {
    if (userData) {
      const userCauses = {};
      userData?.causes?.forEach((cause) => {
        const item = causes.find((c) => c.id === cause.id);
        if (item) {
          userCauses[item.id] = item;
        }
      });
      updateSelectedCauses(userCauses);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, causes]);

  const getUpdatedSelectedList = (selectedList, item, isSelected) => {
    const newSelectedList = { ...selectedList };
    if (isSelected) {
      newSelectedList[item.id] = item;
    } else {
      delete newSelectedList[item.id];
    }
    return newSelectedList;
  };

  const handleCauseSelection = (cause, isSelected) => {
    const selected = getUpdatedSelectedList(selectedCauses, cause, isSelected);
    updateSelectedCauses(selected);
  };
  const handleSearchCause = (searchedCause) => {
    if (!searchedCause || searchedCause.length === 0) {
      setSearchedCauses(causes);
      return;
    }
    const searched = causes?.filter((cause) =>
      cause.cause_title
        .toLowerCase()
        .includes(searchedCause.trim().toLowerCase()),
    );
    if (!isEmpty(searched)) {
      setSearchedCauses(searched);
    }
  };

  const causesLength = Object.keys(selectedCauses).length;

  return (
    <div className="flex flex-col items-start justify-start gap-4">
      <div className="flex w-full">
        <Search
          placeholder="Search Causes"
          onChange={(val) => handleSearchCause(val)}
        />
      </div>
      {/* <div className="flex flex-col">
        <Typography variant="h5">CAUSES SUPPORTED BY YOU</Typography>
        <Stack
          gap={2}
          direction="row"
          flexWrap="wrap"
          className="overflow-y-auto max-h-[100px]">
          {userData?.causes?.map((cause) => (
            <ToggleButton
              key={cause.id}
              label={cause.cause_title}
              selected
              disabled
              color="secondary"
              onToggle={() => {}}
            />
          ))}
        </Stack>
      </div> */}
      <div className="flex flex-col">
        <div className="flex w-full flex-row justify-between">
          <div className="flex-flow-col">
            <Typography variant="h5">SELECT YOUR FAVOURITE CAUSES</Typography>
          </div>
          <div className="mr-1 flex items-center gap-1">
            <Image
              width={12}
              height={9}
              src="/assets/images/Tick.png"
              alt="Tick"
            />
            <Typography variant="body2">{causesLength}</Typography>
          </div>
        </div>
        <div
          // className="flex flex-row flex-wrap gap-4"
          className="mt-3 flex max-h-[300px] flex-row flex-wrap gap-4 overflow-y-auto">
          {[...(!isEmpty(searchedCauses) ? searchedCauses : causes)]?.map(
            (cause) => (
              <ToggleButton
                key={cause.id}
                label={cause.cause_title}
                selected={
                  !!searchedCauses[cause.cause_title] ||
                  !!userData?.causes?.find(
                    (userCause) => userCause.id === cause.id,
                  )
                }
                color="secondary"
                onToggle={(status) => handleCauseSelection(cause, status)}
              />
            ),
          )}
        </div>
      </div>
      <div className="flex-rows flex w-full justify-end gap-4 pb-4">
        {/* <div className="flex-flow-col">
          <Button
            variant="outlined"
            color="primary"
            className="mt-2"
            onClick={onBack}>
            Back
          </Button>
        </div> */}
        {true ? (
          <div className="flex-flow-col">
            <StyledContainedButton
              variant="filled"
              color="primary"
              type="submit"
              className="mt-2"
              loading={saving}
              onClick={() => onSubmit({}, 'Causes Supported')}>
              Save
            </StyledContainedButton>
          </div>
        ) : (
          <div className="flex-flow-col">
            <StyledContainedButton
              disabled={true}
              variant="outlined"
              color="primary"
              type="submit"
              className="mt-2"
              loading={saving}
              onClick={() => onSubmit({}, 'Causes Supported')}>
              Save
            </StyledContainedButton>
          </div>
        )}
      </div>
    </div>
  );
}

export default EditProfileCausesStep;
